import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';

const Branches = () => {
  return (
    <section id="branches" className="branches-section">
      <div className="branches-container animate-fade-in-up">
        <div className="features-header">
          <h2 className="section-title">فروعنا</h2>
          <p className="section-subtitle">نحن أقرب إليك لتلبية كافة احتياجاتك</p>
        </div>

        <div className="branches-grid">
          {/* Branch 1 - Lebanon */}
          <div className="branch-card">
            <div className="branch-icon-wrapper">
              <FaMapMarkerAlt size={28} />
            </div>
            <h3 className="branch-title">فرع لبنان</h3>
            <div className="branch-details">
              <div className="detail-item">
                <span className="detail-label">العنوان:</span>
                <span className="detail-value">بيروت، تل الخياط</span>
              </div>
              <div className="detail-item">
                <FaPhoneAlt className="phone-icon" />
                <a href="tel:+96181752389" className="detail-value phone-link" dir="ltr">+961 81 752 389</a>
              </div>
            </div>
          </div>

          {/* Branch 2 - Syria */}
          <div className="branch-card">
            <div className="branch-icon-wrapper">
              <FaMapMarkerAlt size={28} />
            </div>
            <h3 className="branch-title">فرع سوريا</h3>
            <div className="branch-details">
              <div className="detail-item">
                <span className="detail-label">العنوان:</span>
                <span className="detail-value">ريف دمشق، داريا، شارع الثورة، مفرق جامع العباس</span>
              </div>
              <div className="detail-item">
                <FaPhoneAlt className="phone-icon" />
                <a href="tel:+963997219854" className="detail-value phone-link" dir="ltr">+963 997 219 854</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Branches;
